// questionMSDQ.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OptionsInfo } from "./Cells/Cell";

// Each dropdown option
// interface Option {
//     id: string;
//     label: string;
// }

// Each cell in our grid
export interface CellInfo {
  id: string;
  imageUrl: string;
  altText: string;
  options: OptionsInfo[];
  selectedOption: string;
  correctOption: string;
  correctFeedback: string;
  incorrectFeedback: string;
  correct: boolean;
  answered: boolean;
}

// Shape of the quiz slice state
interface QuizState {
  cells: CellInfo[];
  submitted: boolean;
  globalFeedback: string;
  allCorrect: boolean;
  initialised: boolean;
}

// Our initial state
const initialState: QuizState = {
  cells: [],
  submitted: false,
  globalFeedback: "",
  allCorrect: false,
  initialised: false,
};

// For selecting an option
interface SelectOptionPayload {
  cellId: string;
  optionId: string;
}

const questionMSDQ = createSlice({
  name: "quiz",
  initialState,
  reducers: {
    selectOption: (state, action: PayloadAction<SelectOptionPayload>) => {
      const { cellId, optionId } = action.payload;
      const cell = state.cells.find((c) => c.id === cellId);
      if (cell) {
        const cellIndex = state.cells.findIndex((c) => c.id === cellId);
        if (cellIndex !== -1) {
          state.cells[cellIndex] = {
            ...state.cells[cellIndex],
            selectedOption: optionId,
          };
          state.submitted = false;
          state.globalFeedback = "";
        }
      }
    },
    submitQuiz: (state) => {
      state.submitted = true;
      const allCorrect = state.cells.every(
        (cell) => cell.correctOption === cell.selectedOption
      );
      state.cells = state.cells.map((cell) => {
        if (cell.selectedOption === cell.correctOption) {
          return { ...cell, correct: true, answered: true };
        } else if (
          cell.selectedOption === null ||
          cell.selectedOption === "" ||
          cell.selectedOption === undefined
        ) {
          return { ...cell, correct: false, answered: false };
        } else {
          return { ...cell, correct: false, answered: true };
        }
      });
      if (!allCorrect) {
        state.globalFeedback =
          "Try again. You haven’t selected all the correct answers.";
        state.allCorrect = false;
      } else {
        state.globalFeedback = "Correct!";
        state.allCorrect = true;
      }
    },
    initialiseQuiz: (state, action: PayloadAction<CellInfo[]>) => {
      state.cells = action.payload;
      state.initialised = true;
    },
  },
});

export const { selectOption, submitQuiz, initialiseQuiz } =
  questionMSDQ.actions;
export default questionMSDQ.reducer;
